import { AlertOutlined } from "@ant-design/icons"
import { Button, ButtonProps } from "components/Button/Button"
import { useNotification } from "components/Notification/Notification"
import { CreateEscalationPayload } from "interface/escalation"
import { useNavigate, useParams } from "react-router"
import { useCreateEscalation } from "services/escalations"
import { GENERIC_ERROR_MESSAGE } from "utils/constants"

export function CreateEscalation({
	payload = { observations: "" },
	children = "Create escalation",
	...props
}: ButtonProps & { payload?: CreateEscalationPayload }) {
	const { scopeId, userId: patientId } = useParams()
	const createEscalation = useCreateEscalation(patientId)
	const navigate = useNavigate()
	const { notify } = useNotification()
	const handleClick = async () => {
		if (createEscalation.isPending) {
			return
		}
		createEscalation.mutate(payload, {
			onSuccess: ({ id }) => {
				navigate(`/${scopeId}/patients/${patientId}/escalations/${id}`)
			},
			onError: ({ message = GENERIC_ERROR_MESSAGE }) => {
				notify.error({ message })
			},
		})
	}

	return (
		<Button
			{...props}
			icon={<AlertOutlined aria-hidden />}
			onClick={handleClick}
			loading={createEscalation.isPending}
		>
			{children}
		</Button>
	)
}
